/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import styles from './BrandAbout.module.scss';
import Container from '../../../templates/Container';
import logoBrand from '../../../../assets/img/logoBrand.png';
import imagePDF from '../../../../assets/img/pdfImage.png';
import Arrow from '../../../../assets/img/brand_arrow.svg';

const BrandAbout = () => {
  return (
    <section className={styles.section}>
      <Container>
        <div className={styles.wrapper}>
          <div className={styles.logo}>
            <img src={logoBrand} />
          </div>
          <h1 className={styles.title}>
            <span>Присоединяйся</span> к&nbsp;программе поддержки и&nbsp;продвижения брендов Красноярского края
          </h1>

          <p className={styles.text}>программа предлагает местным брендам набор инструментов для:</p>

          <ul className={styles.list}>
            <li>продвижения на&nbsp;внутреннем и&nbsp;внешнем рынках</li>
            <li>стимулирования сбыта</li>
            <li>формирования спроса</li>
            <li>повышения конкурентоспособности</li>
          </ul>

          <img className={styles.arrow} src={Arrow} alt="" />
          <a
            className={styles.order}
            href="http://www.zakon.krskstate.ru/dat/bin/docs_attach/192703_938_r.pdf"
            // download
            target="_blank"
            rel="noopener noreferrer"
            title="Переход по внешней ссылке">
            <img src={imagePDF} />
            <span>Подробнее</span>
          </a>
        </div>
      </Container>
    </section>
  );
};

export default BrandAbout;
